export { default } from './Sellings';
